const CRAPI_URL = 'https://api.crunchyroll.com'
const CRAPI_AUTH_ID = process.env.GATSBY_PROD_CRAPI_AUTH_ID || ''
const CR_ETP_URL = 'https://www.crunchyroll.com'
const SEGMENT_HOST = 'eec.crunchyroll.com/v1'
const FALLBACK_SEGMENT_HOST = 'sa.etp-prod.com/analytics.js/v1/'
const COOKIE_DOMAIN = '.crunchyroll.com'
const SSO_URL = 'https://sso.crunchyroll.com'
const AVATARS_STATIC_URL = 'https://static.crunchyroll.com'
const NEWSAPI_URL = 'https://cr-news-api-service.prd.crunchyrollsvc.com/v1/'
const ENV = 'prod'

export default {
  env: ENV,
  domain: CR_ETP_URL,
  crApiUrl: CRAPI_URL,
  crApiAuthId: CRAPI_AUTH_ID,
  crEtpUrl: CR_ETP_URL,
  cookieDomain: COOKIE_DOMAIN,
  segment: {
    segmentHost: SEGMENT_HOST,
    fallbackLibraryHost: FALLBACK_SEGMENT_HOST,
    writeKey: process.env.GATSBY_PROD_SEGMENT_WRITE_KEY || '',
  },
  segmentGen2: {
    segmentHost: SEGMENT_HOST,
    fallbackLibraryHost: FALLBACK_SEGMENT_HOST,
    sourceID: process.env.GATSBY_PROD_SEGMENT2_SOURCE_ID || '',
    writeKey: process.env.GATSBY_PROD_SEGMENT2_WRITE_KEY || '',
  },
  ssoUrl: SSO_URL,
  avatarsStaticUrl: AVATARS_STATIC_URL,
  newsApiUrl: NEWSAPI_URL,
}
